import React from "react";

// Liste de faits « libellé / valeur » (dl), portée du kit Fiche du back-office.
// facts : [{ id, label, value, mono, render, truncate }]
// `truncate` : valeur sur une ligne avec ellipse (le libellé complet reste
// lisible au survol).
const FactList = ({ facts = [], emptyLabel = "—", className = "" }) => (
  <dl className={`fact-list ${className}`.trim()}>
    {facts.map((fact) => {
      const isEmpty = fact.value === undefined || fact.value === null || fact.value === "";
      return (
        <div
          key={fact.id}
          className={`fact${fact.mono ? " fact--mono" : ""}${fact.truncate ? " fact--truncate" : ""}`}
        >
          <dt>{fact.label}</dt>
          <dd>
            {fact.render ? (
              fact.render(fact.value)
            ) : isEmpty ? (
              <span className="fact__empty">{emptyLabel}</span>
            ) : (
              <span
                className="fact__value"
                title={fact.truncate && typeof fact.value === "string" ? fact.value : undefined}
              >
                {fact.value}
              </span>
            )}
          </dd>
        </div>
      );
    })}
  </dl>
);

export default FactList;
